"use client"
import Script from "next/script"
import { useEffect, useState } from "react"

interface FacebookPixelProps {
    pixelId?: string
    loadOnInteraction?: boolean
}

export default function FacebookPixel(props: FacebookPixelProps) {
    const { pixelId, loadOnInteraction = true } = props
    const [shouldLoad, setShouldLoad] = useState(!loadOnInteraction)

    useEffect(() => {
        if (!loadOnInteraction || !pixelId || typeof window === 'undefined' || shouldLoad) return

        let interactionDetected = false

        const loadOnUserInteraction = () => {
            if (interactionDetected) return
            interactionDetected = true
            setShouldLoad(true)
        }

        // Загружаем Facebook Pixel только при первом взаимодействии пользователя
        // Это предотвращает загрузку third-party cookies до взаимодействия
        const events = ['mousedown', 'touchstart', 'keydown', 'scroll']
        events.forEach((event) => {
            document.addEventListener(event, loadOnUserInteraction, { once: true, passive: true })
        })

        return () => {
            events.forEach((event) => {
                document.removeEventListener(event, loadOnUserInteraction)
            })
        }
    }, [loadOnInteraction, pixelId, shouldLoad])

    if (!pixelId) return null

    // Не загружаем скрипт до взаимодействия пользователя
    if (!shouldLoad) {
        return null
    }

    return (
        <>
            <Script id="fb-pixel" strategy="lazyOnload">
                {`
                    !function(f,b,e,v,n,t,s){
                        if(f.fbq)return;
                        n=f.fbq=function(){n.callMethod?n.callMethod.apply(n,arguments):n.queue.push(arguments)};
                        if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
                        n.queue=[];t=b.createElement(e);t.async=!0;
                        t.src=v;s=b.getElementsByTagName(e)[0];
                        s.parentNode.insertBefore(t,s)
                    }(window, document,'script','https://connect.facebook.net/en_US/fbevents.js');
                    fbq('init', '${pixelId}');
                    fbq('track', 'PageView');
                `}
            </Script>
            <noscript>
                {/* eslint-disable-next-line @next/next/no-img-element */}
                <img
                    height={1}
                    width={1}
                    style={{ display: "none" }}
                    src={`https://www.facebook.com/tr?id=${pixelId}&ev=PageView&noscript=1`}
                    alt=""
                />
            </noscript>
        </>
    )
}


